// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__IzQLz","icon":"styles_icon__1pHsx"};